// import { NgModule } from '@angular/core';
// import { Routes, RouterModule } from '@angular/router';

// const routes: Routes = [];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
// export class AppRoutingModule { }


import { ModuleWithProviders } from '@angular/compiler/src/core';
import { RouterModule, Routes } from '@angular/router';
// import { AlwaysAuthGuard } from './common/AuthGuard/AuthGuard';
import { LoginModule } from './login/login.module';
import { EnterpriseModule } from './enterprise/enterprise.module';
import { PartnerModule } from './partner/partner.module';
import { StoreModule } from './store/store.module';
import { UserModule } from './user/user.module';
import { LayoutComponent } from './shared/layout/layout.component';
import { PhoneModelsModule } from './phone-models/phone-models.module';
import { UploadPriceModule } from './upload-price/uploadprices.module';
import { UploadPriceDenmarkModule } from './upload-price-denmark/upload-price-denmark.module';
//import {ManageCatalogModule } from '../app/managecatalog/managecatalog.module';
import { celldeGroupingModule } from './celldetestgroup/celldetestgroup.module'
import { AlwaysAuthGuard } from './Services/auth.service';
import { TradeInProModule } from './Trade-In-Pro/Trade-In-Pro.module'
import { deviceModelModule } from './device-model-alias/device-model.module'
import { warehouseGroupingModule } from './warehousetestgroup/warehousetestgroup.module';
import{UploadLocationModule} from './upload-location/upload-location.module';
import{UploadEANGTIN_MappingModule} from '././upload-EANGTIN_Mapping/upload-EANGTIN_Mapping.module';
import{PhoneGradeModule} from '././grade-base/PhoneGrade/phone-grade.module';
import{PhoneGradeWithSkuModule} from '././grade-base/phonegradewithsku/phone-grade-with-sku.module';
import{PhoneGradingDeductionModule} from '././grade-base/PhoneGradingDeduction/PhoneGradingDeduction.module';
import{FrontPhoneGradingDeductionModule} from '././grade-base/FrontPhoneGradingDeduction/FrontPhoneGradingDeduction.module';

const routing: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => LoginModule },
  {
    path: '', component: LayoutComponent,
    canActivate: [AlwaysAuthGuard],
    children: [
      
      { path: 'EANGTIN', loadChildren: () => UploadEANGTIN_MappingModule },
      { path: 'UploadPrice', loadChildren: () => UploadPriceModule },
      { path: 'UploadPriceDenmark', loadChildren: () => UploadPriceDenmarkModule },
      { path: 'UploadStoreInfo', loadChildren: () => UploadLocationModule },
      { path: 'baseEnterprise', loadChildren: () => EnterpriseModule },
      { path: 'enterprise', loadChildren: () => PartnerModule },
      { path: 'store', loadChildren: () => StoreModule },
      { path: 'user', loadChildren: () => UserModule },
      { path: 'PhoneModels', loadChildren: () => PhoneModelsModule },
      // { path: 'ManageCatalog', loadChildren: () => ManageCatalogModule },
      { path: 'DeductionPolicy', loadChildren: () => celldeGroupingModule },
      { path: 'TradeInProModule', loadChildren: () => TradeInProModule },
      { path: 'deviceModelModule', loadChildren: () => deviceModelModule },
      { path: 'WarehouseGrouping', loadChildren: () => warehouseGroupingModule },


        // Grade Base //
        { path: 'grades-deduction', loadChildren: () => PhoneGradeModule  },
        { path: 'upload-sku-prices', loadChildren: () => PhoneGradeWithSkuModule  },
        { path: 'grade-based-prices',loadChildren: () => PhoneGradingDeductionModule },
        { path: 'Frontgrade-based-prices',loadChildren: () => FrontPhoneGradingDeductionModule }
        
        // Grade Base //
    ]
  },
];

export const routModule: ModuleWithProviders = RouterModule.forRoot(routing);


